import { AddOns } from "@nova/constants"
import { FunctionComponent } from "react"
import * as Icons from "@nova/component-icons"

interface AddOnIconProps {
    addOn: AddOns
}
export const AddOnIcon: FunctionComponent<AddOnIconProps> = ({ addOn }) => {
    switch (addOn) {
        case AddOns.Hotspots:
            return <Icons.SmallIcon Icon={Icons.HotspotAddOn} />
        case AddOns.Colorfinder:
            return <Icons.SmallIcon Icon={Icons.ColorfinderAddOn} />
        case AddOns.LiveVideo:
            return <Icons.SmallIcon Icon={Icons.LiveVideoAddOn} />
        default:
            return null
    }
}
